import { useEffect, useState } from "react";
import axios from "axios";
import { GraduationCap, Users, ChevronDown, ChevronUp } from "lucide-react";
import AdminListPage from "@/admin/AdminListPage";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const STATUS_LABEL = {
  draft: { label: "Rascunho", klass: "bg-amber-100 text-amber-800" },
  published: { label: "Publicada", klass: "bg-emerald-100 text-emerald-800" },
  archived: { label: "Arquivada", klass: "bg-gray-100 text-gray-700" },
};

// Inscritos nos Percursos de Auto-Educação (por edição).
function PercursosEnrollments() {
  const [editions, setEditions] = useState([]);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    axios.get(`${API}/itineraries/manage/editions`, { withCredentials: true })
      .then((r) => setEditions((r.data.items || []).filter((e) => e.participant_count > 0 || e.status === "published")))
      .catch(() => {});
  }, []);

  if (!editions.length) return null;

  return (
    <div className="px-8 pb-12 lg:px-12" data-testid="percursos-enrollments">
      <div className="overline">Percursos de auto-educação</div>
      <h2 className="display-heading text-2xl mt-2">Inscritos nos percursos.</h2>
      <div className="mt-5 space-y-3 max-w-4xl">
        {editions.map((e) => (
          <div key={e.id} className="bg-white border border-[hsl(var(--border))]" data-testid={`percurso-enrollments-${e.id}`}>
            <button onClick={() => setOpen(open === e.id ? null : e.id)}
              className="w-full flex items-center justify-between gap-3 p-4 text-left"
              data-testid={`percurso-toggle-${e.id}`}>
              <div>
                <div className="font-medium text-sm">
                  <GraduationCap className="inline h-4 w-4 mr-1.5 text-[hsl(var(--accent))]" />
                  {e.itinerary_title} · <span className="text-[hsl(var(--accent))]">{e.title}</span>
                </div>
                <div className="text-xs text-[hsl(var(--muted-foreground))] mt-1">
                  <Users className="inline h-3 w-3 mr-1" />
                  {e.participant_count} inscrito(s){e.capacity ? ` / ${e.capacity}` : ""}
                </div>
              </div>
              <div className="flex items-center gap-2 shrink-0">
                <span className={`text-xs px-2 py-1 ${STATUS_LABEL[e.status]?.klass || ""}`}>{STATUS_LABEL[e.status]?.label || e.status}</span>
                {open === e.id ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
              </div>
            </button>
            {open === e.id && (
              <div className="border-t border-[hsl(var(--border))] p-4">
                {(e.participants || []).length === 0 ? (
                  <p className="text-sm text-[hsl(var(--muted-foreground))]">Ainda sem inscritos.</p>
                ) : (
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="text-left text-[10px] uppercase tracking-[0.16em] text-[hsl(var(--muted-foreground))]">
                        <th className="pb-2">Nome</th>
                        <th className="pb-2">Email</th>
                        <th className="pb-2">Inscrito em</th>
                        <th className="pb-2">Por</th>
                      </tr>
                    </thead>
                    <tbody>
                      {e.participants.map((p) => (
                        <tr key={p.member_id} className="border-t border-[hsl(var(--border))]" data-testid={`percurso-participant-${p.member_id}`}>
                          <td className="py-2">{p.name}</td>
                          <td className="py-2 text-[hsl(var(--muted-foreground))]">{p.email}</td>
                          <td className="py-2 text-[hsl(var(--muted-foreground))]">{p.enrolled_at ? new Date(p.enrolled_at).toLocaleDateString("pt-PT") : "—"}</td>
                          <td className="py-2 text-[hsl(var(--muted-foreground))]">{p.enrolled_by === "self" ? "Próprio" : p.enrolled_by}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

// Página de Inscrições: RSVPs de eventos + inscritos nos percursos.
export default function AdminInscricoes() {
  return (
    <div data-testid="admin-inscricoes-page">
      <AdminListPage overline="Inscrições" title="Inscrições · todos os eventos"
        type="rsvps" endpoint="/admin/rsvps?event=__all__"
        csvUrl="/admin/rsvps.csv?event=__all__"
        archiveBase="/admin/rsvps" defaultEmpty="Ainda sem inscrições." />
      <PercursosEnrollments />
    </div>
  );
}
